<template>
    <page :loading="loading">
        <div slot="header" class="flex-row">
        	<div class="flex-item page_header">
        		<el-form size="medium" :inline="true">
					<el-form-item label="搜索">
						<el-input v-model="table.search.keyword" placeholder="请输入昵称/联系电话" clearable />
					</el-form-item>
					<el-form-item label="用户ID">
						<el-input v-model="table.search.id" placeholder="请输入用户ID" clearable />
					</el-form-item>
					<el-form-item label="状态">
						<el-select clearable v-model="table.search.status" placeholder="请选择">
						    <el-option :value="1" label="正常"></el-option>
						    <el-option :value="0" label="禁用"></el-option>
						</el-select>
					</el-form-item>
        			<el-form-item>
        				<el-button size="small" type="primary" plain @click="LoadDatas(1,20)">
        					查询
        				</el-button>
        				<el-button size="small" type="info" plain @click="reset">
        					重置
        				</el-button>
        				<el-button size="small" type="success" plain @click="exportExcel" :loading="exportLoading">
        					导出Excel
        				</el-button>
        			</el-form-item>
        		</el-form>
        	</div>
        </div>

        <page-table @sortChange="sortChange" :datas="table.data" :page="table.search._page" :size="table.search._size" :total="table._count" @change="LoadDatas">
            <el-table-column prop="id" sortable="custom" label="ID" align="center" fixed="left"  width="60" />
			<el-table-column prop="avatar" label="头像" align="center" show-overflow-tooltip>
				<template slot-scope="scope">
					<el-avatar :size="50" shape="square" :src="$img(scope.row.avatar)"></el-avatar>
				</template>
			</el-table-column>
			<el-table-column prop='nickname'                       label='昵称' align='center'/>
			<el-table-column prop='phone'                          label='手机号' align='center'/>
			<el-table-column label="推荐人" align="center" show-overflow-tooltip>
				<template slot-scope="scope" >
					<div v-if="scope.row.parent">
						<el-avatar :size="30" shape="square" :src="$img(scope.row.parent.avatar)"></el-avatar>
						<div>{{ scope.row.parent.nickname }}</div>
					</div>
					<div v-else>无</div>
				</template>
			</el-table-column>
			<el-table-column prop='status'                         label='状态' align='center'>
			    <template slot-scope="scope">
			    	<el-tag v-if="scope.row.status">正常</el-tag>
			    	<el-tag v-else type="danger">封禁</el-tag>
			    </template>
			</el-table-column>
			<el-table-column prop='created_at' sortable="custom" label='注册时间' align='center'/>
            <el-table-column label="操作" align="center" fixed="right" width="120">
                <template slot-scope="scope">
                    <el-button type="text" size="small" @click="getInfo(scope.row)">详情</el-button>
                </template>
            </el-table-column>
        </page-table>
		
		<el-drawer :modal="false" v-if="showDrawer" title="用户信息" size="50%" :visible.sync="showDrawer">
			<info @save="save()" :data="info"/>
		</el-drawer>
    </page>
</template>
<script>
import info from '../component/info.vue';
export default {
	components: {
		info
	},
    data(){
        return {
            loading: false,
			exportLoading: false, // 导出加载状态
            table:{
                data: [],
                form: {},
                search: {
                    _page: 1,
                    _size: 20,
                },
            	_count: 0,
            },
			departmentList: [],
			positionList: [],
			showDrawer: false,
			info: {},
        }
    },
    mounted() {
		this.LoadDatas();
    },
    methods: {
		async exportExcel() {
			this.exportLoading = true;
			try {
				// 构建导出参数
				const exportParams = this.$buildExportParams(this.table.search);
		
				// 调用导出
				await this.$export('userExport', exportParams, '用户列表');
			} catch (error) {
				this.$message.warning(error);
			} finally {
				this.exportLoading = false;
			}
		},
		sortChange(e){
			var isreverse =  1;
			if( e.order == null ){
				this.reset();
			}else if( e.order == 'descending' ){
				var isreverse = 1;
			}else if ( e.order == 'ascending' ){
				var isreverse = 0;
			}
			this.table.search = {
				_page: 1,
				_size: 20,
				_order: e.prop,
				_isreverse: isreverse
			};
			this.LoadDatas();
		},
		getInfo(info){
			 this.info = info;
			 this.showDrawer = true
		},
		save(){
			this.showDrawer = false;
			this.info = {};
			this.reset();
		},
		reset(){
			this.table.search = {
				_page:1,
				_size:20,
			};
			this.LoadDatas();
		},
        /**
         * 获取数据列表
         * @param page 分页-当前页
         * @param limit 分页-每页数量
         * **/
        LoadDatas(page,limit){
            page && (this.table.search._page = page),limit && (this.table.search._size = limit),this.loading = true;
            this.$get('app-user',this.table.search).then(res=>
            {   
                this.table.data = res.data, this.table._count = res.extra.pageInfo.count, this.loading = false;
            }).catch(err=>
            {
                this.$warning(err), this.loading = false;
            });
        },
        /**
         * 保存
         * @param item 要保存的数据
         * **/
        ActionSave(item){
            this.loading = true;
            this.$save('app-user',item).then(res=>
            {
                this.loading = false, this.LoadDatas(), this.$success('操作成功'), this.showDialog = false;
            }).catch(err=>
            {
                this.loading = false , this.$warning(err);
            });
        },
    },
}
</script>

<style lang="scss" scoped>
	.page_header {
		margin:10px 10px 0;
		position: absolute;
		z-index: 100;
	}
</style>